import { lazy, Suspense } from "react";
import Header from "@/components/Header";
import HonestHero from "@/components/home/HonestHero";
import StackLayersRow from "@/components/home/StackLayersRow";
import DeferredSection from "@/components/home/DeferredSection";
import AboutUsBand from "@/components/home/AboutUsBand";
import WhoPaysUs from "@/components/home/WhoPaysUs";
import NoCommissionCompare from "@/components/home/NoCommissionCompare";
// Below-the-fold sections are lazy-loaded so their JS does not block the
// hero's first paint. Keep Header + HonestHero eager for LCP.
//
// The homepage is deliberately Stack-first: hero -> 4 Stack layers ->
// "everything else" -> proof -> guides -> close. The retired sections
// (MeetHomieIntro, MeetYourGuides, HomieAndStack, StackSpotlight,
// RewardsLadder, HonestTruthList, ContrastTable, HomiePathSteps,
// HomieChatPreview, ExpertVoicesStrip) still live in src/components/home/
// and can be reused on landing pages.
const EverythingElse = lazy(() => import("@/components/home/EverythingElse"));
const FeaturedGuides = lazy(() => import("@/components/home/FeaturedGuides"));
const HonestBottomCTA = lazy(() => import("@/components/home/HonestBottomCTA"));
const Footer = lazy(() => import("@/components/Footer"));
const ForEmployersBand = lazy(() => import("@/components/home/ForEmployersBand"));
const ExpertQuoteStrip = lazy(() => import("@/components/home/ExpertQuoteStrip"));
const StickyMobileCTA = lazy(() => import("@/components/home/StickyMobileCTA"));
const ExitIntentHomie = lazy(() => import("@/components/home/ExitIntentHomie"));
import PageMeta from "@/components/PageMeta";
import { useAuth } from "@/hooks/useAuth";
import { HOMEPAGE_TITLE, HOMEPAGE_DESCRIPTION } from "@/lib/homepageSchema";

const Index = () => {
  useAuth();

  return (
    <div className="min-h-screen bg-background">
      <Header />
      {/*
        No jsonLd prop here: the homepage's full JSON-LD graph (see
        src/lib/homepageSchema.ts) is baked directly into dist/index.html at
        build time (vite.config.ts's prerender plugin) so non-JS crawlers see
        it without executing React. Also passing it through Helmet here would
        add a second, duplicate <script type="application/ld+json"> on
        hydration — Helmet appends rather than replacing the static one.
        JSON-LD has no user-visible effect, so skipping it on client-side SPA
        navigation to "/" costs nothing; crawlers always fetch a fresh
        document per URL rather than simulating SPA route changes.
      */}
      <PageMeta
        title={HOMEPAGE_TITLE}
        description={HOMEPAGE_DESCRIPTION}
        path="/"
      />
      <main className="home-indigo">
        <HonestHero />
        <StackLayersRow />
        <NoCommissionCompare />
        <Suspense fallback={null}>
          <EverythingElse />
        </Suspense>
        <DeferredSection minHeight="200px">
          <ExpertQuoteStrip />
        </DeferredSection>
        <DeferredSection minHeight="520px">
          <FeaturedGuides />
        </DeferredSection>
        <DeferredSection minHeight="420px">
          <HonestBottomCTA />
        </DeferredSection>
        <WhoPaysUs />
        <Suspense fallback={null}>
          <ForEmployersBand />
        </Suspense>
        <AboutUsBand />
      </main>
      <Suspense fallback={null}>
        <Footer />
        <StickyMobileCTA />
        <ExitIntentHomie />
      </Suspense>
    </div>
  );
};

export default Index;

